import React, { FC, FocusEvent } from 'react'
import { Input } from 'antd'

interface ICustomInput {
    ref?: any
    onChange?: any
    [string: string]: any
}

const createNoSpace = (WrapperInput: any): FC<ICustomInput> => ({ ref, onChange, ...props }) => {
    const handleBlur = (e: FocusEvent<HTMLInputElement>): void => {
        e.target.value = e.target.value.trim()
        if (typeof onChange === 'function') {
            onChange(e.target.value)
        }
    }
    const handleInput = (e: FocusEvent<HTMLInputElement>): void => {
        if (typeof onChange === 'function') {
            onChange(e.target.value)
        }
    }
    const handleChange = (e: FocusEvent<HTMLInputElement>): void => {
        if (e.currentTarget.value === '') {
            onChange('')
        }
    }
    return <WrapperInput
        ref={ref}
        maxLength={255}
        onBlur={handleBlur}
        onInput={handleInput}
        onChange={handleChange}
        {...props}
    />
}

export default createNoSpace(Input)
